import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Message} from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';

@Component({
  selector: 'app-apqp-document',
  templateUrl: './apqp-document.component.html',
  styleUrls: ['./apqp-document.component.scss']
})
export class ApqpDocumentComponent implements OnInit {

  msgs: Message[] = [];
  constructor(private route: Router, public _apiService: ApiServiceService, private confirmationService: ConfirmationService , private primengConfig: PrimeNGConfig , private _utility : AppUtility,private fb :FormBuilder) { }
  errorMsg: string = ''
  errorMsgCheck: string = ''
  suppliers: any;
  header : string = 'Document Status'
  loading: boolean = true;
  document_dropdown: any = [];
  supplier_dropdown: any = [];
  supplierId : any;
  display : boolean = false;
  apqplisting:any=[];
  role:any;
  filterval:any;
  excelData: any[] = [];
  @ViewChild('fileInput') fileInput: ElementRef;
documentmodal:boolean=false
  ngOnInit(): void {
      this.getStatic();
      this.getAllTableData();
      this.loading = false;
      this.primengConfig.ripple = true;
      this.supplierId = this._utility.getLocalStorageDetails();
      this.supplierId = this.supplierId.supplierId
    this.role = JSON.parse(localStorage.getItem("UserObject"));
  }

  breadcrumb = [
      {
          title: 'APQP Documents',
          subTitle: 'Dashboard'
      }
  ]

  getStatic() {
      this._apiService.dropdowndata('document')
      .then((res: any) => {
          this.document_dropdown = res.returnValue;
      })
  }

  clear(table: any) {
      table.clear();
  }

  filePath: any = {};
  getDocument(value: any) {
    this.filePath = this._utility.onFileChange(value);
  }

  getAllTableData() {
    this._utility.loader(true);
      this._apiService.getapqpdetails().then((res:any)=>{
        this._utility.loader(false);
          if(res.success == true){
            this.apqplisting = res.returnValue;
          }
          else {
            this.apqplisting = [];
            this.errorMsg = res.message;
            this.errorMsgCheck = 'error'
            this._apiService.showMessage(this.errorMsg , this.errorMsgCheck);
          }
        })
  }


  default_status : any;
  documentData : any;
  checkerdata:any=[]
  checker2display:boolean=false;
  openModel(role:any){
    console.log(role,"cjekcerrrerer");
    
    // this.default_status = document.isApproved ? 1 : 3
    // this.documentData = document;
    // console.log(this.default_status);    
     this.checkerdata= this.apqplisting.filter(item => item.selectedItems);  
     if (this.checkerdata.length == 0) {
            this._apiService.showMessage('Please Select Atleast One Part', "error")
            return;
        }
    if (role=='checker1'){
    this.display = true;
    }
    else{
      this.checker2display=true;
    }
     
  }
checkerRemark:string
updateStatus(isApproved: any) {
  console.log(isApproved);

  this._utility.loader(true);
  this.documentData = document;
  this.display = true;

  const selectedData = this.apqplisting.filter(item => item.selectedItems);
  if (!selectedData.length) {
    this._utility.loader(false);
    this._apiService.showMessage('No item selected.', 'error');
    return;
  }

  const object = new FormData();
  object.append("APQPId", selectedData[0].apqpId);

  if (isApproved === 'approve') {
    object.append("Checker1Remark", this.checkerRemark);

    this._apiService.putAPQPDocument(object)
      .then((res: any) => {
        this._utility.loader(false);
        this.display = false;

        if (res?.success) {
          this._apiService.showMessage(res.message, "success");
          this.getAllTableData()
        } else {
          this._apiService.showMessage(res.message , "error");
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.display = false;
        this.checkerRemark=''
          this.fileInput.nativeElement.value = null;
        this._apiService.showMessage(error.message , "error");
      });

  } else {
    object.append("Checker1Remark", this.checkerRemark);
    object.append("ReworkUpload", this.reworkfile);
    this._apiService.reworkAPQPDocument(object)
      .then((res: any) => {
        this._utility.loader(false);
        this.display = false;

        if (res?.success) {
          this._apiService.showMessage(res.message , "success");
          this.getAllTableData()
        } else {
          this._apiService.showMessage(res.message , "error");
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.display = false;
         this.checkerRemark=''
           this.fileInput.nativeElement.value = null
        this._apiService.showMessage(error.message , "error");
      });
  }
}


 toolLoanForm = this.fb.group({
    uploadDoc: new FormControl(null, [Validators.required]),
    SupplierRemark:new FormControl(null)
  });
  // getFile(event) {
  //   let file = this._utility.onFileChange(event);
  //   console.log("file");
    
  //   this.toolLoanForm.controls['uploadDoc'].setValue(file);
  // }
  reworkfile:File;
  getFile(event: Event,role:any) {
  const input = event.target as HTMLInputElement;
   if(role =='supplier'){
  if (input.files && input.files.length > 0) {
    const file = input.files[0];

    // Store the file object in the FormControl
    this.toolLoanForm.get('uploadDoc')?.setValue(file);

  }
}
else if (role =='checker'){
    if (input.files && input.files.length > 0) {
    const file = input.files[0]; 
     console.log(file);
     this.reworkfile=file
  }
}
}

  resetform() {
    this.toolLoanForm.reset();
    setTimeout(() => {
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = null;
      } else {
        console.warn("fileInput is still null");
      }
    });

  }
  submitForm() {

    if (this.toolLoanForm.valid) {
      this._utility.loader(true)
      let formData = new FormData();
    const selectedData = this.apqplisting.filter(item => item.selectedItems);
            // formData.append('SupplierId', selectedData[0]?.supplierId),
           formData.append('OrderNumber',selectedData[0]?.orderNumber),
            formData.append('LineNumber', selectedData[0]?.lineNumber),
            //  ItemDescription: selectedData[0]?.itemDesc,
            // ItemNumber: selectedData[0]?.itemNumber,
      // formData.append('ToolLoanDetailIds', this.check1CommaSeparatedValues);
      // formData.append('DocumentName', this.toolLoanForm.controls.docName.value);
      formData.append('Remark', this.toolLoanForm.controls.SupplierRemark.value);
      formData.append('file', this.toolLoanForm.controls.uploadDoc.value);

      this._apiService.updateapqp(formData).then((res: any) => {
        this._utility.loader(false)
        if (res.success == false) {
          this._apiService.showMessage(res.message, "error");
        } else {
          this._apiService.showMessage(res.message, "success");
          this.documentmodal = false
          this.fileInput.nativeElement.value = null;
          this.getAllTableData()
        }
      });
      this.display = false
    } else {
      this._apiService.showMessage("Please fill form details", "error");
    }
  }
  selectedItems:any
  sendSelectedData() {
     const selectedData = this.apqplisting.filter(item => item.selectedItems);
     if (selectedData.length == 0) {
            this._apiService.showMessage('Please Select Atleast One Part', "error")
            return;
        }
    this.documentmodal=true
 
    // console.log("Selected Items:", this.selectedItems);

    // console.log(toolId,"tool id");
    // this.toollistStringId = toolId
    // this._utility.loader(true)
    // this._apiService.getpackagebydetail(toolId).then((res) => {
    //   if (res['success']) {
    //     this.packagedatabyid = res['returnValue']
    //   }
    //   this.approveModalState = true;
    //   this._utility.loader(false)
    // });
    // console.log(data, modal, 'toolid: ', this.toollistStringId);
  }
 
updateCheckboxState() {
  const selectedCount = this.apqplisting.filter(tool => tool.selectedItems).length;
  this.apqplisting.forEach(tool => {
    tool.disabled = selectedCount > 0 && !tool.selectedItems;
  });
}
reset(dt2){
   dt2.reset();
  this.filterval = '' 
}
  onXLSExport() {
    let filteredBy

    for (let i = 0; i < this.apqplisting.length; i++) {
   
      this.excelData.push({
        'S.No.': i + 1,
         'Supplier Name': this.apqplisting[i]?.supplierName ?? '-',
        'Order Number': this.apqplisting[i]?.orderNumber ?? '-',
        'Line Number': this.apqplisting[i]?.lineNumber ?? '-',
        'Item Number': this.apqplisting[i]?.itemNumber ?? '-',
        'Description 1': this.apqplisting[i]?.itemDescription ?? '-',
      });


    }
    this._apiService.exportExcel(this.excelData, 'APQP-list', filteredBy);
  }
  checker2Remark:string;
   checker2verification(isApproved: any) {
  console.log(isApproved);

  this._utility.loader(true);
  this.documentData = document;
  this.checker2display = true;

  const selectedData = this.apqplisting.filter(item => item.selectedItems);
  if (!selectedData.length) {
    this._utility.loader(false);
    this._apiService.showMessage('No item selected.', 'error');
    return;
  }

  const object = new FormData();
  object.append("APQPId", selectedData[0].apqpId);

  if (isApproved === 'approve') {
    object.append("Checker2Remark", this.checker2Remark);

    this._apiService.apqpApprovechecker2Document(object)
      .then((res: any) => {
        this._utility.loader(false);
        this.checker2display = false;

        if (res?.success) {
          this._apiService.showMessage(res.message, "success");
          this.getAllTableData()
        } else {
          this._apiService.showMessage(res.message , "error");
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.checker2display = false;
        this.checker2Remark=''
          this.fileInput.nativeElement.value = null;
        this._apiService.showMessage(error.message , "error");
      });

  } else {
    object.append("Checker2Remark", this.checker2Remark);
    object.append("ReworkUploadChecker2",this.reworkfile)
    this._apiService.reworkAPQPchecker2Document(object)
      .then((res: any) => {
        this._utility.loader(false);
        this.checker2display = false;

        if (res?.success) {
          this._apiService.showMessage(res.message , "success");
          this.getAllTableData()
        } else {
          this._apiService.showMessage(res.message , "error");
        }
      })
      .catch((error: any) => {
        this._utility.loader(false);
        this.checker2display = false;
         this.checker2Remark=''
           this.fileInput.nativeElement.value = null;
        this._apiService.showMessage(error.message , "error");
      });
  }
}
}
